var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighPayoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.426,
    height: 84.69,
    viewBox: "0 0 78.426 84.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8644",
    "data-name": "Rectangle 8644",
    width: 78.426,
    height: 84.69,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40748",
    "data-name": "Group 40748",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42378",
    "data-name": "Path 42378",
    d: "M36.76,84.69c-1.466-.208-2.938-.378-4.4-.631a38.022,38.022,0,0,1-19.514-9.6,39.146,39.146,0,0,1,7.97-63.564c1.56-.808,3.189-1.492,4.817-2.157s3.029-.123,3.565,1.288-.188,2.719-1.822,3.346A33.772,33.772,0,0,0,7.235,33.331,34.225,34.225,0,1,0,47.113,12.168c-.319-.076-.642-.136-.963-.2l-.226.241a12.623,12.623,0,0,1,1.25,1A2.477,2.477,0,1,1,43.7,16.725q-3.092-3.047-6.138-6.141a2.448,2.448,0,0,1,.031-3.674q3.02-3.061,6.081-6.081A2.481,2.481,0,1,1,47.2,4.307c-.7.739-1.426,1.456-2.139,2.184-.017.017-.015.052-.049.178q1.067.212,2.126.423a39.2,39.2,0,0,1-.291,76.85c-1.453.3-2.944.4-4.417.6-.24.032-.476.1-.713.147Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42379",
    "data-name": "Path 42379",
    d: "M87.707,90.526A25.482,25.482,0,1,1,62.26,116,25.495,25.495,0,0,1,87.707,90.526m.071,4.962a20.52,20.52,0,1,0,20.484,20.535A20.525,20.525,0,0,0,87.778,95.488",
    transform: "translate(-48.502 -70.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42380",
    "data-name": "Path 42380",
    d: "M145.838,162.076c-1.562-.726-2.989-1.292-4.317-2.034a2.4,2.4,0,0,1-.885-3.488,2.429,2.429,0,0,1,3.481-.688,6.837,6.837,0,0,0,4.324,1.062,3.463,3.463,0,0,0,3.315-3.2,2.489,2.489,0,0,0-1.75-2.606c-1.447-.6-2.906-1.171-4.347-1.786a14.426,14.426,0,0,1-1.449-.787,6.119,6.119,0,0,1-3.31-6.252,6.872,6.872,0,0,1,4.241-6.031,1.01,1.01,0,0,0,.727-1.079,2.5,2.5,0,0,1,2.434-2.523,2.472,2.472,0,0,1,2.495,2.529.749.749,0,0,0,.6.808,13.125,13.125,0,0,1,2.364,1.149,2.467,2.467,0,1,1-2.677,4.141,4.3,4.3,0,0,0-3.7-.579,2.135,2.135,0,0,0-1.541,1.944,1.543,1.543,0,0,0,1.089,1.737c1.477.666,2.951,1.345,4.46,1.933,3.355,1.307,5.3,3.864,5.337,7.116a8.447,8.447,0,0,1-5.159,7.8c-.455.188-.785.323-.777.953A2.493,2.493,0,0,1,148.338,165c-1.443,0-2.428-1.118-2.491-2.819,0-.108-.019-.216-.009-.109",
    transform: "translate(-109.237 -103.348)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighPayoutIcon);
export default __webpack_public_path__ + "static/media/high-payout-icon.f59027905f1bcdd1a1f4f646bcb556b0.svg";
export { ForwardRef as ReactComponent };